import React from 'react';

const ConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  message,
  ampSection
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-4 rounded shadow-md">
        <div className="flex flex-col gap-2">
          {message}
        </div>
        <div className="flex justify-end mt-4">
          <button 
            onClick={onClose} 
            className="mr-2 bg-gray-300 px-4 py-2 rounded"
            data-amp-track-section={ampSection}
            data-amp-track-action="Cancel_Click"
            data-amp-track-description="Cancel Confirmation"
          >
            Cancel
          </button>
          <button 
            onClick={onConfirm} 
            className="bg-red-500 text-white px-4 py-2 rounded"
            data-amp-track-section={ampSection}
            data-amp-track-action="Confirm_Click"
            data-amp-track-description="Confirm Confirmation"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;